//                             ____                                 _           __
//     ____  ____ __________ _/ / /___ __  __   ____  _________    (_)__  _____/ /_
//    / __ \/ __ `/ ___/ __ `/ / / __ `/ |/_/  / __ \/ ___/ __ \  / / _ \/ ___/ __/
//   / /_/ / /_/ / /  / /_/ / / / /_/ />  <   / /_/ / /  / /_/ / / /  __/ /__/ /_
//  / .___/\__,_/_/   \__,_/_/_/\__,_/_/|_|  / .___/_/   \____/_/ /\___/\___/\__/
// /_/                                      /_/              /___/

/* globals */

import { app } from './app';
import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import anime from 'animejs/lib/anime.es.js';

const setupProjectParallax = figure => {
  console.log('{ setupProjectParallax }');

  // init controller
  const controller = app.controller;

  const figureH = figure.offsetHeight;

  const distImage = figureH * 0.12;
  const distShadow = figureH * 0.04;

  const imageWrap = figure.querySelector('.parallax__image-wrap');
  const shadowWrap = figure.querySelector('.parallax__shadow-wrap');

  // console.groupCollapsed( '{ parallax }' );
  // console.log( 'figure: %o', figure );
  // console.log( 'shadowWrap: %o', shadowWrap );
  // console.log( 'imageWrap: %o', imageWrap );
  // console.log( 'figureH: %o', figureH );
  // console.groupEnd();

  const timeline = anime.timeline({
    duration: 100, // 0-100 to match event.progress * 100 below
    easing: 'linear',
    autoplay: false,
    loop: false
  });

  timeline.add({
    targets: imageWrap,
    translateY: [distImage, distImage * -1]
  });

  // desktop only
  if ($('.barba-container').hasClass('desktop')) {
    // project image shadow?
    if (shadowWrap) {
      // console.log( 'timeline: imageWrap: %o', imageWrap );
      // console.log( 'timeline: shadowWrap: %o', shadowWrap );

      timeline.add(
        {
          targets: shadowWrap,
          translateY: [distShadow * 2, 0],
          opacity: [1, 0.4]
        },
        '-=100'
      ); // offset time to keep in-sync with main image
    }
  }

  // create a scene
  new ScrollMagic.Scene({
    triggerHook: 1,
    triggerElement: figure,
    duration: figureH * 2 // double element height - top enter viewport to bottom leave
  })
    .on('progress', function (e) {
      timeline.seek(e.progress * 100);
    })
    .addTo(controller); // assign the scene to the controller
};

// ----------------------------------------------------------------------------
//
// Chevron Parallax
//
// ----------------------------------------------------------------------------
const setupChevronParallax = () => {
  console.log('{ setupChevronParallax }');

  // init controller
  const controller = app.controller;
  const chevrons = document.getElementsByClassName('js-sr_chevron');

  // console.log( 'chevrons: %o', chevrons );

  $.each(chevrons, (i, el) => {
    const parent = el.parentNode;
    const parentH = parent.offsetHeight;
    const dist = parentH * 0.15;

    const timeline = anime.timeline({
      duration: 100, // 0-100 to match event.progress * 100 below
      easing: 'linear',
      autoplay: false,
      loop: false
    });

    timeline.add({
      targets: el,
      translateY: [dist * -1, dist]
    });

    // create a scene
    new ScrollMagic.Scene({
      triggerHook: 1,
      triggerElement: parent,
      duration: parentH * 2 // double element height - top enter viewport to bottom leave
    })
      .on('progress', function (e) {
        timeline.seek(e.progress * 100);
      })
      .addTo(controller); // assign the scene to the controller
  });
};

export { setupProjectParallax, setupChevronParallax };



// WEBPACK FOOTER //
// ./scripts/modules/parallax.js